import React, { useState } from 'react';
import { FaGithub, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';
import emailjs from 'emailjs-com';

const Contact = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleFormSubmit = (e) => {
    e.preventDefault();

    // Send the email using EmailJS
    emailjs.init('a.arunsivaofficial@gmail.com');
    emailjs.sendForm('service_epjlpci', 'template_zxriyoz', e.target, 'a.arunsivaoffcial@gmail.com')
      .then((result) => {
        console.log(result.text);
        // Reset form fields
        setName('');
        setEmail('');
        setMessage('');
        alert('Message sent successfully!');
      })
      .catch((error) => {
        console.error('Error sending message:', error);
        alert('Failed to send message. Please try again later or try LinkedIn.');
      });
  };

  return (
    <div id="Contact" className="section mt-60 lg:mt-80">
      <div className="mx-auto flex flex-col lg:flex-row border-2 border-white/50 rounded-xl shadow-xl shadow-white">
        <motion.div
          variants={fadeIn('left', 0.2)}
          initial="hidden"
          whileInView={'show'}
          viewport={{ once: false, amount: 0.2 }}
          className="p-10"
        >
          <h1 className="h1 text-fuchsia-600 text-[40px] mb-6"> Contact me through..</h1>
          <div className="flex flex-col text-fuchsia-200 gap-y-6 lg:m-0 ">
            <a href="https://www.linkedin.com/in/ArunkumarA03"><FaLinkedin /> LinkedIn</a>
            <a href="https://github.com/Arunsiva003"><FaGithub /> Github</a>
            <a href="#"><FaInstagram /> Instagram</a>
          </div>
        </motion.div>
        <motion.div
          variants={fadeIn('right', 0.2)}
          initial="hidden"
          whileInView={'show'}
          viewport={{ once: false, amount: 0.7 }}
          className="p-10"
        >
          <h1 className="h1 text-fuchsia-600 mb-6">Message </h1>

          <form onSubmit={handleFormSubmit}>
            <div className="flex flex-col">
              <input
                className="bg-transparent border-b py-3 outline-none w-full placeholder:text-white focus:border-accent transition-all"
                type="text"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <input
                className="bg-transparent border-b py-3 outline-none w-full placeholder:text-white focus:border-accent transition-all"
                type="email"
                placeholder="Mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <textarea
                className="bg-transparent border-b py-12 outline-none w-full placeholder:text-white focus:border-accent transition-all"
                placeholder="Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-sm mt-10 content-center">
    Send
  </button>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;
